import { useEffect } from "react";
import type { AxiosError } from "axios";
import { useSnackbar } from "notistack";

const AUTHORIZED_ERROR_STATUS = 401;
const FORM_ERROR_STATUS = 422;
const METHOD_NOT_ALLOWED = 405;
const INTERNAL_SERVER_ERROR = 500;

const isAuthorizedError = (err?: AxiosError) =>
  err && err.response?.status === AUTHORIZED_ERROR_STATUS;

const isMethodAllowed = (err?: AxiosError) =>
  err && err.response?.status === METHOD_NOT_ALLOWED;
export const isFormError = (err?: AxiosError) =>
  err && err.response?.status === FORM_ERROR_STATUS;
const isInternalServerError = (err?: AxiosError) =>
  err && err.response?.status === INTERNAL_SERVER_ERROR;

type ErrorResponse = {
  message: string;
};
export function useErrorResponse(error?: AxiosError | null) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const errorCode = error && error.response?.status;

  const responseMessage = error && (error.response?.data as ErrorResponse);

  useEffect(() => {
    if (error) {
      if (error.response?.status === 401) {
        return ;
      }

      if (isFormError(error)) {
        enqueueSnackbar(`${errorCode}: Form error`);
      } else if (isMethodAllowed(error)) {
        if (errorCode)
          if (errorCode === 401) {
            console.log(responseMessage);
          } else {
            enqueueSnackbar(`${errorCode}: ${MESSAGE_CODE[errorCode]}`);
          }
      } else if (isInternalServerError(error)) {
        if (errorCode)
          enqueueSnackbar(`${errorCode}: ${MESSAGE_CODE[errorCode]}`);
      } else {
        enqueueSnackbar(
          `${errorCode}: ${responseMessage ? responseMessage.message : error.message}`
        );
      }
    }
  }, [error]);

  return null;
}

const MESSAGE_CODE: Record<number, string> = {
  405: "Method Not Allowed.",
  500: "Internal Server Error.",
};
